export const STORE_OPTIONS = [
    { value: 'store_1', label: '912 S Kerr Ave' },
    { value: 'store_2', label: '2307 N College Rd' },
    { value: 'store_3', label: '9 Sunnyvale Dr' },
];

export const STORE_LABEL_BY_VALUE = STORE_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
}, {});

export function getStoreLabel(storeValue) {
    if (!storeValue) return 'Unassigned';
    return STORE_LABEL_BY_VALUE[storeValue] || storeValue;
}
